import http from './httpService'

export function previewEmail(order, isMizodiaStore) {
  console.log('previewEmail', order, isMizodiaStore)
  return http.post(`/email/${isMizodiaStore ? 'mizodia/preview' : 'template'}`, order)
}

export function sendEmail(order, isMizodiaStore = false) {
  return http.post(`/email/${isMizodiaStore ? 'mizodia/send' : 'notify'}`, order)
}
